const Resources = {

    table_headers: [
        { 

            text:     'Description',
            align:    'start',
            type:     'link',
            value:    'description'
        },
        {
            text:       'Associate',
            value:      'associate'
        },
        {
            text:       'Date',
            value:      'date'
        },
        {
            text:       'Responsability',
            value:      'responsability'
        },
        {
            text:       'Unassignmed works',
            value:      'discharge_worksheet_counter'
        },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Census',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Worksheets',
            href:   '/census-worksheets',
            arrow:  "",
        },
    ],

}

export default Resources;